import { render, staticRenderFns } from "./Wechat.vue?vue&type=template&id=59b3d85a&scoped=true&"
import script from "./Wechat.vue?vue&type=script&lang=js&"
export * from "./Wechat.vue?vue&type=script&lang=js&"
import style0 from "./Wechat.vue?vue&type=style&index=0&id=59b3d85a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b3d85a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b3d85a')) {
      api.createRecord('59b3d85a', component.options)
    } else {
      api.reload('59b3d85a', component.options)
    }
    module.hot.accept("./Wechat.vue?vue&type=template&id=59b3d85a&scoped=true&", function () {
      api.rerender('59b3d85a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/secure/bind/Wechat.vue"
export default component.exports